//
//
//
//
//
//
//
//
//
//
//
//
//


import common from "@/assets/js/Common.js";
import api from "@/assets/js/Api.js";

import inputbox from '@/components/ui/inputbox';

export default {
    components: {inputbox},
    data(){
        return {
            info: {
                name: '',
                pwd: '',
                referid: '',
            },

        }
    },
    methods:{

        // 登录
        submit(){

            const info = this.info;

            if(info.name.length<1){
                this.$vux.toast.text("用户名不能为空");
                return;
            }

            if(info.pwd.length < 1){
                this.$vux.toast.text("密码不能为空");
                return;
            }

            const opts = {
                url: api.loginPwd,
                data: {
                    ...info,
                },
                type: 'post',
            }
            common.query(opts).then(res=>{
                common.storage("userInfo",JSON.stringify(res.data));
                const callback = common.storage("callback") || "/member";

                common.storage("callback",'');
                common.storage("referid",'');

                this.$router.push(callback);
            },res=>{
                this.$vux.toast.text(res.message)
            });

        },


    },
    mounted(){
        this.info.referid = common.storage("referid") || '';
    },
}




// WEBPACK FOOTER //
// ./src/views/login/loginBox/pwdLogin.vue